import Component from 'core/Component';
import { on, off } from 'toolbox/event';
import { Event } from 'services/EventEmitter';

/**
 * This is a description of the BazaarvoiceRatingsSummary constructor function.
 * @class
 * @classdesc Component used to emit BazaarVoice events on specific actions.
 * @extends Component
 */
export default class BazaarvoiceRatingsSummary extends Component {
    /**
     * Should contain only event listeners and nothing else
     * All the event handlers should be into a separated function. No usage of anonyous function
     */
    bindEvents() {
        on('click', this.element, this.onClick.bind(this));
        Event.once('BV.dependency.check', this.afterInit, this);
        Event.on('product.url.updated', this.onProductUrlUpdated, this);
    }

    /**
     * After init
     * Run any script after the component is fully initialized
     */
    afterInit() {
        Event.emit('BV.dependency.loaded');
    }

    /**
     * Emits an event when clicking on review button.
     * @param {Object} event - event data
     */
    onClick(event) {
        if (event.target.id === 'WAR') {
            Event.emit('analytics.event', {
                category: 'product detail page',
                action: 'write review',
                label: this.analytics.label,
                extraData: {
                    event_name: 'write_review',
                    product_info: this.analytics.label,
                },
            });

            Event.emit('BV.review.write', {
                category: 'product detail page',
                label: this.analytics.label,
            });
        }
    }

    /**
     * Update product review SVG fill URL when product URL is updated
     */
    onProductUrlUpdated() {
        this.element.querySelectorAll('#ratings-summary path').forEach((path) => {
            // Expected fill URL format example:
            // url("https://<host>/s/NGLora/en_GB/NG337040-LAC.html?dwvar_NG337040-LAC_color=334_Insta-Rose#bv_rating_summary_star_filled_1_0_99.99_NG337040-LAC") !important
            const fillURL = path.style.fill;

            // Store the Gradient ID after the hash
            const linearGradientID = fillURL.split('#')[1].split('"')[0];

            // Build the new fill URL
            path.setAttribute('style', `fill: url("${window.location.href}#${linearGradientID}") !important`);
        });
    }

    /**
     * Destroy is called automatically after the component is being removed from the DOM
     * You must always destroy the listeners attached to an element to avoid any memory leaks
     */
    destroy() {
        off('click', this.element);
        Event.removeListener('BV.dependency.check', this.afterInit, this);
        Event.removeListener('product.url.updated', this.onProductUrlUpdated, this);
    }
}
